import { create } from 'zustand';

export type IAreaFilter = {
  area: string;
  subareas: string[];
  subjects: string[];
};

export type ICompleteFilter = IAreaFilter[] | { area: string }[];

interface IPracticeConfigState {
  title: string;
  areasFilter: ICompleteFilter;
  courseId: string;
  courseWeekId: string;
  hasCronometer: boolean;
  cronometer: string;
  difficulty: string[];
  essayCorrectionType: string;
  essayThemeAxis: string;
  hasEssay: boolean;
  hasVideoResolution: boolean;
  hasntDone: boolean;
  questionsNumber: string;
  simulationType: string;
  institutionType: string[];
  questionsOrigin: string;
  error: boolean;
  selectedYear: string[];
  setSelectedYear: (years: string[]) => void;
  setTitle: (title: string) => void;
  setAreasFilter: (areas: ICompleteFilter) => void;
  setCourseId: (id: string) => void;
  setCourseWeekId: (id: string) => void;
  setHasCronometer: (choice: boolean) => void;
  setCronometer: (time: string) => void;
  setDifficulty: (level: string[]) => void;
  setEssayCorrectionType: (type: string) => void;
  setEssayThemeAxis: (axis: string) => void;
  setHasntDone: (done: boolean) => void;
  setHasEssay: (choice: boolean) => void;
  setHasVideoResolution: (choice: boolean) => void;
  setQuestionsNumber: (questions: string) => void;
  setSimulationType: (type: string) => void;
  setInstitutionType: (types: string[]) => void;
  setQuestionsOrigin: (origin: string) => void;
  setError: (error: boolean) => void;
  resetConfig: () => void;
}

export const practiceConfigStore = create<IPracticeConfigState>((set) => ({
  courseId: '',
  courseWeekId: '',
  title: '',
  areasFilter: [],
  hasCronometer: false,
  cronometer: '',
  difficulty: [],
  essayCorrectionType: '',
  essayThemeAxis: '',
  hasEssay: false,
  hasVideoResolution: false,
  hasntDone: false,
  questionsNumber: '',
  simulationType: '',
  institutionType: [],
  questionsOrigin: 'all',
  error: false,
  selectedYear: [],
  setSelectedYear: (years) => set({ selectedYear: years }),
  setAreasFilter: (areas: ICompleteFilter) => set({ areasFilter: areas }),
  setCourseId: (id: string) => set({ courseId: id }),
  setCourseWeekId: (id: string) => set({ courseWeekId: id }),
  setHasCronometer:(choice: boolean) => set({ hasCronometer: choice }),
  setCronometer: (time: string) => set({ cronometer: time }),
  setDifficulty: (level: string[]) => set({ difficulty: level }),
  setEssayCorrectionType: (type: string) => set({ essayCorrectionType: type }),
  setEssayThemeAxis: (axis: string) => set({ essayThemeAxis: axis }),
  setHasEssay: (choice: boolean) => set({ hasEssay: choice }),
  setHasVideoResolution: (choice: boolean) =>
    set({ hasVideoResolution: choice }),
  setHasntDone: (done: boolean) => set({ hasntDone: done }),
  setQuestionsNumber: (questions: string) =>
    set({ questionsNumber: questions }),
  setSimulationType: (type: string) => set({ simulationType: type }),
  setInstitutionType: (types: string[]) => set({ institutionType: types }),
  setTitle: (title: string) => set({ title }),
  setQuestionsOrigin: (origin: string) => set({ questionsOrigin: origin }),
  setError: (error: boolean) => set({ error }),
  resetConfig: () =>
    set({
      courseId: '',
      courseWeekId: '',
      title: '',
      areasFilter: [],
      hasCronometer: false,
      cronometer: '',
      difficulty: [],
      essayCorrectionType: '',
      essayThemeAxis: '',
      hasEssay: false,
      hasVideoResolution: false,
      hasntDone: false,
      questionsNumber: '',
      selectedYear: [],
      simulationType: '',
      institutionType: [],
      questionsOrigin: 'all',
    }),
}));
